import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import TextField from "../common/TextField"
import UMCButton from "../common/UMCButton"
import PasswordField from "../common/PasswordField"
import { setContentLoading, setSubHeading } from "../../store/reducers/CommonReducer"
import OxeData from "./OxeData"
import { oxeLogin } from "../../store/actions/OxeActions"
import { getLocalItem, getSessionItem } from "../../utils/storageUtils"
import { CC_PRODUCT_ID, GIVENNAME, IS_POD, ROLE, SURNAME } from "../../utils/Constants"
import aleLogo from "../../assets/images/ale-logo.jpg"
import warning from "../../assets/images/icon_warning.svg"
import { formatDictString, getRole, getTranslated } from "../../utils/CommonUtils"
import { sendGTMEvent } from "../../utils/GTMUtils"

const OxeLogin = (props) => {

    const [error, setError] = useState("")
    const [isFailed, setIsFailed] = useState(false)
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")

    const unameRef = useRef()

    const oxeAuthStatus = useSelector((state) => state.oxe.oxeAuthStatus)
    const oxeUmcConnected = useSelector((state) => state.oxe.oxeUmcConnected)
    const dict = useSelector(state => state.common.dict)

    const dispatch = useDispatch()

    useEffect(() => {
        unameRef?.current?.focus()
    }, [])

    useEffect(() => {
        const heading = oxeAuthStatus ? "" : formatDictString(dict, "MSG_WELCOME", { username: `${getLocalItem(GIVENNAME)} ${getLocalItem(SURNAME)}`, role: getRole() })
        dispatch(setSubHeading(heading))
    }, [oxeAuthStatus, dict])

    useEffect(() => {
        setError((oxeUmcConnected === true || oxeUmcConnected === undefined) ? "" : getTranslated(dict, "ERR_OXE_DISCONNECTED"))
    }, [oxeUmcConnected, dict])

    const onFinish = () => {
        // Handle login
        setError("")
        setIsFailed(false)
        dispatch(setContentLoading(true))

        const postData = new URLSearchParams({
            oxeUserName: userName,
            oxePassword: password,
            ccProductId: getSessionItem(CC_PRODUCT_ID),
            isPod: getSessionItem(IS_POD),
            role: getSessionItem(ROLE)
        })

        dispatch(oxeLogin(postData, (status) => {
            dispatch(setContentLoading(false))

            // Push to GTM datalayer
            sendGTMEvent({
                event: "umc_oxe_login",
                status: status ? "Success" : "Failure",
            })

            if (!status) {
                setError(getTranslated(dict, "ERR_AUTH_FAILED"))
                setIsFailed(true)
                // dispatch(setContentLoading(false))
            }
        }))
    }

    const updateUsername = (value) => {
        setUserName(value)
    }

    const updatePassword = (value) => {
        setPassword(value)
    }


    return <>
        {oxeAuthStatus ? <OxeData /> : <div style={{ textAlign: "center" }}>
            {/* <div className="error-status-txt" style={{ fontSize: "1.3em", fontWeight: "bold" }}>
                UMC is under Beta-test and must not be used by Client/BP not officially referenced as Beta partner
            </div> */}
            <img src={aleLogo} alt="ALE-logo" className="ale-logo" />
            {(error) ? <div style={{ margin: "1em 0" }}>
                <img src={warning} alt="Warning" style={{ height: "1.5em" }} />
                <p className="login-status error-status-txt">{error}</p>
                {isFailed && <>
                    <div>{getTranslated(dict, "ERR_OXE_WRONG_CREDS")}</div>
                    <div>{getTranslated(dict, "ERR_OXE_BLOCKED")}</div>
                    <div>{getTranslated(dict, "ERR_OXE_LOG")}</div>
                </>}
            </div> :
                <p className="login-status">{getTranslated(dict, "MSG_OXE_ACCESS")}</p>}
            <div className="field-wrap">
                <div className="oxe-login-label">{getTranslated(dict, "LABEL_OXE_LOGIN")}:</div>
                {isFailed && <img src={warning} alt="Warning" className="warning-icon" />}
                <TextField
                    className="input-text"
                    placeholder={getTranslated(dict, "PH_OXE_LOGIN")}
                    status={isFailed ? "error" : ""}
                    handleChange={updateUsername}
                    onPressEnter={(event) => (userName && password && oxeUmcConnected === true) && onFinish()}
                    ref={unameRef}
                />
            </div>
            <div className="field-wrap">
                <div className="oxe-login-label">{getTranslated(dict, "LABEL_OXE_PASSWORD")}:</div>
                {isFailed && <img src={warning} alt="Warning" className="warning-icon" />}
                <PasswordField
                    className="input-text"
                    placeholder={getTranslated(dict, "PH_OXE_PASSWORD")}
                    status={isFailed ? "error" : ""}
                    handleChange={updatePassword}
                    onPressEnter={(event) => (userName && password && oxeUmcConnected === true) && onFinish()}
                />
            </div>

            <UMCButton
                className="login-form-button"
                label={getTranslated(dict, "LABEL_LOGIN")}
                type="primary"
                onClick={onFinish}
                disabled={!(userName && password)}
            />
        </div>}
    </>
}

export default OxeLogin